import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';

/**
 * Professional language switcher pill — Arabic ↔ English.
 * - Toggles document direction (rtl/ltr) and persists to localStorage.
 * - Visually shows current language with a globe icon and a small "switch hint".
 */
export default function LanguageSwitcher({ variant = 'light', className = '' }) {
  const { i18n } = useTranslation();
  const current = i18n.language === 'en' ? 'en' : 'ar';
  const next = current === 'ar' ? 'en' : 'ar';
  const nextLabel = next === 'ar' ? 'العربية' : 'English';

  const handleToggle = () => i18n.changeLanguage(next);

  const isDark = variant === 'dark';
  return (
    <button
      type="button"
      onClick={handleToggle}
      aria-label="Toggle language"
      data-testid="lang-switcher-btn"
      className={
        `group inline-flex items-center gap-2 rounded-full px-3 py-1.5 text-xs font-bold transition-all duration-200 shadow-sm ` +
        (isDark
          ? 'bg-white/10 backdrop-blur-sm border border-white/20 text-white hover:bg-white/15 hover:border-[#e9c87b]/50 '
          : 'bg-white border border-slate-200 text-[#0f3457] hover:border-[#1a4d80] hover:shadow-md ') +
        className
      }
    >
      <Globe size={14} className={isDark ? 'text-[#e9c87b]' : 'text-[#1a4d80]'}/>
      <span className="tracking-wide">{nextLabel}</span>
      <span className={`text-[10px] font-normal opacity-60 ${isDark ? 'text-white/80' : 'text-slate-500'}`} dir="ltr">
        {current.toUpperCase()} → {next.toUpperCase()}
      </span>
    </button>
  );
}
